<div class="pb-2">
  <ng-container *ngFor="let option of to.options | formlySelectOptions:field | async; let i=index;">
    <span style="display: flex;" class="mt-2">
      <input type="radio" [name]="id" [id]="id + '_' + i" [value]="option.value" [formControl]="formControl"
        [formlyAttributes]="field" kendoRadioButton class="ml-4" />
      <label [class]="to.className + ' k-radio-label'" [for]="id + '_' + i">{{ option.label }}</label>
    </span>
  </ng-container>
  <small *ngIf="to.description" class="form-text text-muted ml-4">{{ to.description }}</small>
</div>